import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './CircleIcon.css';

export const CircleIcon = ({
  icon,
  img = false,
  circle = true,
  onClick = () => {},
  className = ''
}) => {
  return (
    <div onClick={onClick} className={`circle-icon__container ${className}`}>
      {img ? (
        <img
          src={img}
          alt="icon-img"
          style={{
            maxWidth: '100%',
            maxHeigth: '100%',
            width: 'auto',
            heigth: 'auto',
            objectFit: 'cover',
            borderRadius: circle ? '100%' : '1%'
          }}
        />
      ) : (
        <FontAwesomeIcon icon={icon} />
      )}
    </div>
  );
};
